// src/components/services/ServicesHeroSection.jsx
import React from "react";

const ServicesHeroSection = () => {
  const heroStyle = {
    background:
      "linear-gradient(135deg, #000000 0%, #0891b2 50%, #000000 100%)",
    color: "white",
    textAlign: "center",
    padding: "6rem 0",
  };

  const containerStyle = {
    // maxWidth: "1200px",
    margin: "0 auto",
    // padding: "0 1.5rem",
  };

  return (
    <section style={heroStyle}>
      <div style={containerStyle}>
        <h1
          style={{
            fontSize: "3.5rem",
            fontWeight: "bold",
            marginBottom: "1rem",
          }}
        >
          Professional Bowling Services
        </h1>
        <p
          style={{
            fontSize: "1.25rem",
            color: "#e0e0e0",
            maxWidth: "600px",
            margin: "0 auto",
          }}
        >
          Expert drilling, maintenance, and customization services to elevate
          your bowling performance
        </p>
      </div>
    </section>
  );
};

export default ServicesHeroSection;
